module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fullmapview"
  }, [_c('svg', {
    ref: "svg",
    staticClass: ".svg-pan-zoom_viewport",
    attrs: {
      "id": "svg-map",
      "viewBox": '0 0 ' + _vm.map.map_width + ' ' + _vm.map.map_height
    }
  }, [_c('image', {
    attrs: {
      "xlink:href": require("../../../assets/full_map.jpg"),
      "x": 0,
      "y": 0,
      "width": _vm.map.map_width,
      "height": _vm.map.map_height
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "zoomBtnContainer"
    }
  }, [_c('li', [_c('el-button', {
    attrs: {
      "id": "zoomInBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.zoomIn()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-button', {
    attrs: {
      "id": "zoomOutBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.zoomOut()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "minus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('el-button', {
    attrs: {
      "id": "zoomResetBtn"
    },
    on: {
      "click": function($event) {
        _vm.panZoomObj.resetZoom();
        _vm.panZoomObj.resetPan()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrows-alt"
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e5df696"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/hackingmap/FullMapView.vue
// module id = 967
// module chunks = 1